import { Injectable } from '@angular/core';

import { AuthStateService } from './auth-state.service';
import { RouteAuthPolicy } from '../models';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  constructor(private readonly authStateService: AuthStateService) {}

  hasAccess(policy?: RouteAuthPolicy): boolean {
    if (!policy) {
      return true;
    }

    const roleNames = this.authStateService.roleNames().map((role) => role.toLowerCase());
    const permissionSlugs = this.authStateService.permissionSlugs().map((permission) => permission.toLowerCase());

    return this.matchesAny(policy.anyRoles, roleNames)
      && this.matchesAll(policy.allRoles, roleNames)
      && this.matchesAny(policy.anyPermissions, permissionSlugs)
      && this.matchesAll(policy.allPermissions, permissionSlugs);
  }

  private matchesAny(requiredValues: string[] | undefined, availableValues: string[]): boolean {
    if (!requiredValues?.length) {
      return true;
    }

    return requiredValues.some((value) => availableValues.includes(value.toLowerCase()));
  }

  private matchesAll(requiredValues: string[] | undefined, availableValues: string[]): boolean {
    if (!requiredValues?.length) {
      return true;
    }

    return requiredValues.every((value) => availableValues.includes(value.toLowerCase()));
  }
}